/**
 * Message for a hanging protocol that saved but could not be applied.
 *
 * The protocol exists on the server -- only resolving it against this case failed, so the wording says
 * exactly that. Wording that implied the *create* failed would be worse: it sends the user to make the
 * protocol again, where the unique-name check rejects them for one they already own.
 *
 * Reachable only when the payload fetch behind the create's pin fails or comes back empty. A protocol
 * the server's match would not have picked is *not* this case -- creating applies it regardless
 * (VX-4905), so there is nothing to report there.
 */
export const getApplyAfterCreateErrorMessage = (hangingProtocolName: string): string =>
  `Created hanging protocol: ${hangingProtocolName}, but it could not be applied to this study. ` +
  `Select it from the hanging protocol list to try again.`;
